import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getCapexReportAvailableColumns, getDefectActDivisionList } from './api';

export const path = '/reports/capex';

const PageCapexApplicationReports: React.FC = (props) => {
  const CapexApplicationReports = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getCapexReportAvailableColumns,
      defectActDivisionList: getDefectActDivisionList,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <CapexApplicationReports {...props} />;
};

export default PageCapexApplicationReports;
